"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConditionalWrapper = ConditionalWrapper;
var React = _interopRequireWildcard(require("react"));
var _ramda = require("ramda");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable  @typescript-eslint/no-explicit-any */

function ConditionalWrapper(props) {
  const {
    children
  } = props;
  const wrappersProps = React.useMemo(() => (0, _ramda.omit)(['if', 'ThenComponent', 'thenRender', 'ElseComponent', 'elseRender'], props), [props]);
  const condition = typeof props.if === 'function' ? props.if() : props.if;
  if (condition) {
    if (props.ThenComponent) {
      const {
        ThenComponent
      } = props;
      return /*#__PURE__*/React.createElement(ThenComponent, wrappersProps);
    } else {
      return props.thenRender(children);
    }
  } else {
    if (props.ElseComponent) {
      const {
        ElseComponent
      } = props;
      return /*#__PURE__*/React.createElement(ElseComponent, wrappersProps);
    } else if (props.elseRender) {
      return props.elseRender(children);
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }
}